"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from 'react';
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import Image from 'next/image';
import ProductsImagePopup from './ProductsImagePopup';
const ProductGallery = t0 => {
  const $ = _c(17);
  const {
    labels,
    className: t1,
    height: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const height = t2 === undefined ? null : t2;
  const splideRef = useRef();
  const [popupOpen, setPopupOpen] = useState(false);
  const containerClass = className || "w-[175px] h-[120px]";
  const t3 = `${containerClass} overflow-hidden`;
  let t4;
  if ($[0] !== height) {
    t4 = height ? {
      height
    } : {};
    $[0] = height;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      perPage: 1,
      gap: "1rem",
      mediaQuery: "max",
      pagination: false,
      arrows: false
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      height: "100%"
    };
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== labels) {
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = (label, index) => <SplideSlide key={index} onClick={() => setPopupOpen(true)} style={{
        height: "100%"
      }}><div className="w-full h-full flex items-center justify-center p-2"><Image width={400} height={400} src={label.url} alt={label.alt} className="max-w-full max-h-full object-contain rounded-lg" style={{
            maxHeight: "100%"
          }} /></div></SplideSlide>;
      $[6] = t8;
    } else {
      t8 = $[6];
    }
    t7 = labels.map(t8);
    $[4] = labels;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[7] !== t7) {
    t8 = <Splide options={t5} ref={splideRef} style={t6}>{t7}</Splide>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== labels || $[10] !== popupOpen) {
    t9 = popupOpen && <ProductsImagePopup labels={labels || []} onClose={() => setPopupOpen(false)} />;
    $[9] = labels;
    $[10] = popupOpen;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t8 || $[15] !== t9) {
    t10 = <div className={t3} style={t4}>{t8}{t9}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default ProductGallery;